import { render, staticRenderFns } from "./VendorSearch.vue?vue&type=template&id=626be79c"
import script from "./VendorSearch.vue?vue&type=script&lang=js"
export * from "./VendorSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports